// `value` is the API's `type` filter. The label is looked up under `documents:types.<value>` at
// render time, so this module never calls `t()` at import.
export const TYPE_OPTIONS = ['profile', 'waitlist', 'other'] as const;
